/**
 * NoDataAvailableInput is a functional component that displays a message indicating
 * that no data is currently available and prompts the user to insert data in Budget Parameters.
 *
 * @component
 * @example
 * return (
 *   <NoDataAvailableInput />
 * )
 */
export default function NoDataAvailableInput() {
  return (
    <div>
      <h2>
        No data currently available, please insert data in Budget Parameters.
      </h2>
    </div>
  );
}
